import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { trackEvent } from './Analytics';

const LOGO_URL = "/bucktime-name-logo.png";

export const SiteHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  /* Self-managed scroll detection — works on every page */
  useEffect(() => {
    const lp = document.querySelector('.landing-page');
    if (!lp) return;
    const onScroll = () => setScrolled(lp.scrollTop > 80);
    lp.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => lp.removeEventListener('scroll', onScroll);
  }, []);

  /* Close menu on route change */
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const isApple = /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
  const getAppUrl = isApple
    ? 'https://get.bucktime.ca/ios?src=header'
    : 'https://get.bucktime.ca/android?src=header';

  const navLinks = [
    { to: '/about', label: 'About' },
    { to: getAppUrl, label: 'Get the App', isExternal: true },
    { to: '/charities', label: "Dough'Nation" },
    { to: '/resources', label: 'Parent Resources' },
    { to: '/faq', label: 'FAQs' },
    { to: '/contact', label: 'Contact Us' },
  ];

  const handleNavClick = (e, link) => {
    e.preventDefault();
    trackEvent(`nav-${link.label.replace(/\s+/g, '-').toLowerCase()}`, location.pathname);
    setMenuOpen(false);
    if (link.isExternal) {
      window.open(link.to, '_blank');
    } else {
      navigate(link.to);
    }
  };

  const isActive = (link) => {
    if (link.isExternal) return false;
    return location.pathname === link.to;
  };

  return (
    <header className={`site-header ${scrolled ? 'site-header--scrolled' : ''}`} data-testid="site-header">
      <div className="container site-header__inner">
        <img
          src={LOGO_URL}
          alt="BuckTime! logo"
          className="site-header__logo"
          onClick={() => location.pathname !== '/' && navigate('/')}
          style={{ cursor: location.pathname !== '/' ? 'pointer' : 'default' }}
          data-testid="site-logo"
        />

        {/* Hamburger button — visible on mobile only */}
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          data-testid="nav-hamburger"
        >
          <span className={`hamburger-line ${menuOpen ? 'hamburger-open' : ''}`} />
          <span className={`hamburger-line ${menuOpen ? 'hamburger-open' : ''}`} />
          <span className={`hamburger-line ${menuOpen ? 'hamburger-open' : ''}`} />
        </button>

        <nav className={`main-nav ${menuOpen ? 'main-nav--open' : ''}`} data-testid="main-nav">
          {navLinks.map(link => (
            <a
              key={link.to}
              href={link.to}
              className={`nav-link ${isActive(link) ? 'nav-link-active' : ''}`}
              onClick={(e) => handleNavClick(e, link)}
              data-testid={`nav-${link.to.replace(/[\/#]/g, '') || 'waitlist'}`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Docked family image — scales up when scrolled */}
        <img
          src="/family-hero.png"
          alt="BuckTime! characters"
          className="site-header__family-docked"
          data-testid="header-family-docked"
        />
      </div>
    </header>
  );
};

export default SiteHeader;
